// src/pages/BranchLedger/BranchLedgerSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchBranchLedger, fetchBranches } from "./BranchLedgerThunk";

const initialState = {
  list: [],
  loading: false,
  branches: [],
  branchLoading: false,
  filters: {
    branchId: null,
    fromDate: null,
    toDate: null,
  },
};

const branchLedgerSlice = createSlice({
  name: "branchLedger",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchLedger.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchLedger.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBranchLedger.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchBranches.pending, (state) => {
        state.branchLoading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.branchLoading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state) => {
        state.branchLoading = false;
        state.branches = [];
      });
  },
});

export const { setFilters } = branchLedgerSlice.actions;
export default branchLedgerSlice.reducer;
